<template>
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>

    <!-- LISTAGEM -->
    <div v-if="!visualizando">
      <b-row class="text-center">
        <b-col cols="12">
          <div style="margin-bottom:10px"></div>
          <b-col lg="12" class="my-1">
            <b-form-group
              label="Pesquisar"
              label-for="filter-ocorrencia"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-ocorrencia"
                  v-model="filter"
                  type="search"
                  placeholder="Busca por ID, Local, Status..."
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <div style="margin: 10px"></div>
          <b-card bg-variant="light" body-class="p-1 p-md-3" style="min-height: 60vh;">
              <div class="overflow-auto">
                <b-table stacked="md"
                  id="table-ocorrencias"
                  @filtered="onFiltered"
                  :filter="filter"
                  :filter-function="filtroPersonalizado"
                  striped small
                  :fields="fields"
                  :items="ocorrenciasAgrupadas"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  show-empty
                  empty-text="Nenhuma ocorrência encontrada para o seu setor."
                  empty-filtered-text="Nenhuma ocorrência encontrada para esta busca."
                >
                  <template v-slot:cell(detalhes)="row">
                    <b-button size="sm" @click="alternarDetalhes(row)" class="mr-2" variant="outline-primary">
                      {{ row.detailsShowing ? 'Ocultar' : 'Ver Problemas' }}
                    </b-button>
                  </template>
                  <template v-slot:cell(statusGeral)="data">
                    <b-badge :variant="varianteStatusGeral(statusGeralOcorrencia(data.item))">
                      {{ statusGeralOcorrencia(data.item) }}
                    </b-badge>
                  </template>
                  <template v-slot:cell(idOcorrencia)="data">
                    {{ data.item.ocorrencia.idOcorrencia }}
                  </template>
                  <template v-slot:cell(dataOcorrencia)="data">
                    {{ formatarData(data.item.ocorrencia.dataOcorrencia) }}
                  </template>
                  <template v-slot:cell(local)="data">
                    <span v-if="data.item.ocorrencia">
                      {{ data.item.ocorrencia.bloco ? data.item.ocorrencia.bloco.descricao : '' }}
                      <span v-if="data.item.ocorrencia.andar"> / {{ data.item.ocorrencia.andar.descricao }}</span>
                      <span v-if="data.item.ocorrencia.corredor"> / {{ data.item.ocorrencia.corredor.descricao }}</span>
                      <span v-else-if="data.item.ocorrencia.checkList && data.item.ocorrencia.checkList.corredor"> / {{ data.item.ocorrencia.checkList.corredor.descricao }}</span>
                      <span v-if="data.item.ocorrencia.sala"> / {{ data.item.ocorrencia.sala.descricaoCompleta || data.item.ocorrencia.sala.descricao }}</span>
                    </span>
                    <span v-else class="text-muted">-</span>
                  </template>
                  <template v-slot:cell(idCheckList)="data">
                    <b-button v-if="data.item.ocorrencia && data.item.ocorrencia.checkList" 
                              variant="outline-primary" size="sm" class="font-weight-bold"
                              :title="data.item.ocorrencia.checkList.ancora ? 'Visualizar Inventário' : 'Visualizar Checklist'"
                              @click="irParaChecklist(data.item)">
                      <b-icon :icon="data.item.ocorrencia.checkList.ancora ? 'box-seam' : 'card-checklist'" class="mr-1"></b-icon> 
                      {{ data.item.ocorrencia.checkList.ancora ? 'Inv.' : 'Chk.' }} {{ data.item.ocorrencia.checkList.idCheckList }}
                    </b-button>
                    <span v-else class="text-muted">-</span>
                  </template>
                  <template v-slot:cell(qtdProblemas)="data">
                    <b-badge variant="info">{{ data.item.problemas.length }}</b-badge>
                  </template>

                  <!-- Detalhes da Linha Expansível -->
                  <template #row-details="row">
                    <b-collapse :visible="row.item._isCollapseOpen">
                      <b-card header="Problemas Relatados" header-bg-variant="dark" header-text-variant="white" class="mb-2">
                        <b-table 
                          :items="row.item.problemas" 
                          :fields="camposProblemas" 
                          small bordered responsive="sm">
                          
                          <template v-slot:cell(status)="d">
                            <b-badge :variant="getBadgeVariant(d.item)">{{ mapStatus(d.item) }}</b-badge>
                          </template>
                          <template v-slot:cell(problema)="d">
                            {{ d.item.problema ? d.item.problema.descricao : (d.item.observacao || 'Sem descrição') }}
                          </template>
                          <template v-slot:cell(idChamado)="d">
                            {{ d.item.idChamado || '-' }}
                          </template>
                          <template v-slot:cell(anexos)="d">
                            <b-button
                              v-if="d.item.ocorrencia && d.item.ocorrencia.checkList"
                              size="sm"
                              variant="outline-primary"
                              :disabled="!obterIdCheckListItem(d.item) || carregandoAnexosId === d.item.idOcorrenciaProblema"
                              :title="obterIdCheckListItem(d.item) ? 'Visualizar anexos do item relacionado' : 'Ocorrência sem item de checklist relacionado'"
                              @click="abrirAnexos(d.item)"
                            >
                              <b-spinner v-if="carregandoAnexosId === d.item.idOcorrenciaProblema" small class="mr-1" />
                              <span v-else>
                                <b-icon icon="paperclip" />
                                <span class="d-none d-md-inline ml-1">Anexos</span>
                                <b-badge variant="light" class="text-primary ml-1">{{ obterQuantidadeAnexos(d.item) }}</b-badge>
                              </span>
                            </b-button>
                            <span v-else class="text-muted">-</span>
                          </template>

                        </b-table>
                      </b-card>
                    </b-collapse>
                  </template>
                </b-table>
              </div>
              <div class="mt-3 d-flex justify-content-end">
                <b-pagination
                  size="sm"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="table-ocorrencias"
                ></b-pagination>
              </div>
          </b-card>
          <br>
          <div v-if="problemasOrfaos.length > 0">
            <h5 class="text-warning text-left">Problemas Avulsos (Originados de Checklists/Inventários)</h5>
            <b-card bg-variant="light" body-class="p-1 p-md-3">
              <b-table 
                :items="problemasOrfaos" 
                :fields="camposProblemasOrfaos" 
                striped small responsive="sm"
                empty-text="Nenhum item avulso encontrado.">
                
                <template v-slot:cell(status)="d">
                  <b-badge :variant="getBadgeVariant(d.item)">{{ mapStatus(d.item) }}</b-badge>
                </template>
                <template v-slot:cell(problema)="d">
                  {{ d.item.problema ? d.item.problema.descricao : (d.item.observacao || 'Sem descrição') }}
                </template>
                <template v-slot:cell(idCheckListItem)="d">
                  <b-badge variant="secondary" v-if="d.item.idCheckListItem">Chk Item: {{ d.item.idCheckListItem }}</b-badge>
                  <span v-else class="text-muted">-</span>
                </template>
                <template v-slot:cell(anexos)="d">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    :disabled="!obterIdCheckListItem(d.item) || carregandoAnexosId === d.item.idOcorrenciaProblema"
                    :title="obterIdCheckListItem(d.item) ? 'Visualizar anexos' : 'Sem item relacionado'"
                    @click="abrirAnexos(d.item)"
                  >
                    <b-spinner v-if="carregandoAnexosId === d.item.idOcorrenciaProblema" small class="mr-1" />
                    <span v-else>
                      <b-icon icon="paperclip" />
                      <span class="d-none d-md-inline ml-1">Anexos</span>
                      <b-badge variant="light" class="text-primary ml-1">{{ obterQuantidadeAnexos(d.item) }}</b-badge>
                    </span>
                  </b-button>
                </template>
              </b-table>
            </b-card>
            <br>
          </div>
          <b-card bg-variant="light">
            <div class="row" style="float: right">
                <b-button @click="sincronizar" id="btn-sincronizar" style="margin-right: 30px; background-color: #303f9f; color: white; border: none;" size="sm" :disabled="sincronizando">
                  <b-icon :icon="sincronizando ? 'arrow-clockwise' : 'cloud-download'" :animation="sincronizando ? 'spin' : ''"></b-icon> 
                  {{ sincronizando ? 'Sincronizando...' : 'Sincronizar Chamados' }}
                </b-button>   
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <check-list-anexos
      v-if="itemAnexosSelecionado"
      ref="anexosOcorrencia"
      :id-check-list-item="itemAnexosSelecionado.idCheckListItem"
      :nome-item="itemAnexosSelecionado.item && itemAnexosSelecionado.item.nome ? itemAnexosSelecionado.item.nome : ''"
      :anexos="itemAnexosSelecionado.anexos || []"
      habilitado
      :permite-envio="false"
      :permite-exclusao="false"
      :exibe-exclusao="false"
      :exibe-acionador="false"
    />
  </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import CheckListAnexos from '../../components/CheckListAnexos.vue';
import ChecklistService from '../../services/ChecklistService';
import OcorrenciaService from '../../services/OcorrenciaService';

export default {
  name: 'ListagemOcorrencia',
  components: { BarraNavegacao, CheckListAnexos },
  data() {
    return {
      visualizando: false,
      ocorrenciasAgrupadas: [],
      problemasOrfaos: [],
      filter: null,
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      sincronizando: false,
      carregandoAnexosId: null,
      itemAnexosSelecionado: null,
      fields: [
        { key: 'detalhes', label: '' },
        { key: 'idOcorrencia', label: 'ID Ocorrência', sortable: true },
        { key: 'local', label: 'Local' },
        { key: 'dataOcorrencia', label: 'Data', sortable: true },
        { key: 'idCheckList', label: 'Cód. Chk/Inv', sortable: true },
        { key: 'qtdProblemas', label: 'Qtd. Problemas' },
        { key: 'statusGeral', label: 'Status' }
      ],
      camposProblemas: [
        { key: 'idOcorrenciaProblema', label: 'ID Prob.' },
        { key: 'problema', label: 'Problema' },
        { key: 'idChamado', label: 'Chamado Help Desk' },
        { key: 'status', label: 'Status' },
        { key: 'anexos', label: 'Anexos', class: 'text-center' }
      ],
      camposProblemasOrfaos: [
        { key: 'idOcorrenciaProblema', label: 'ID Prob.' },
        { key: 'problema', label: 'Problema' },
        { key: 'idCheckListItem', label: 'Origem (Checklist)' },
        { key: 'idChamado', label: 'Chamado Help Desk' },
        { key: 'status', label: 'Status' },
        { key: 'anexos', label: 'Anexos', class: 'text-center' }
      ]
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  mounted() {
    if (this.$route.query.filtro) {
      this.filter = this.$route.query.filtro;
    }
    this.carregarOcorrencias();
  },
  watch: {
    $route(to) {
      if (to.query.filtro) {
        this.filter = to.query.filtro;
      } else {
        this.filter = null;
      }
    }
  },
  methods: {
    alternarDetalhes(row) {
      if (row.detailsShowing) {
        // Fechando suavemente
        this.$set(row.item, '_isCollapseOpen', false);
        setTimeout(() => {
          row.toggleDetails();
        }, 350); // Aguarda a animação do b-collapse terminar
      } else {
        // Abrindo suavemente
        row.toggleDetails();
        this.$nextTick(() => {
          this.$set(row.item, '_isCollapseOpen', true);
        });
      }
    },
    obterQuantidadeAnexos(itemOcorrencia) {
      if (!itemOcorrencia) return 0;
      if (itemOcorrencia.quantidadeAnexos !== undefined && itemOcorrencia.quantidadeAnexos !== null) {
          return itemOcorrencia.quantidadeAnexos;
      }
      return 0;
    },
    abrirAnexos(itemOcorrencia) {
      const checklist = itemOcorrencia && itemOcorrencia.ocorrencia && itemOcorrencia.ocorrencia.checkList;
      if (!checklist || !checklist.idCheckList) return;
      const idCheckListItem = this.obterIdCheckListItem(itemOcorrencia);
      if (!idCheckListItem) return;
      this.carregandoAnexosId = itemOcorrencia.idOcorrenciaProblema;
      this.itemAnexosSelecionado = null;

      ChecklistService.buscarPorId(checklist.idCheckList)
        .then(response => {
          const itens = response.data && Array.isArray(response.data.itens) ? response.data.itens : [];
          const itemRelacionado = itens.find(item => Number(item.idCheckListItem) === Number(idCheckListItem));
          if (!itemRelacionado) {
            this.alertaMensager('O item relacionado à ocorrência não foi encontrado no checklist.', 'Aviso', 'warning');
            return;
          }
          this.itemAnexosSelecionado = itemRelacionado;
          this.$nextTick(() => {
            if (this.$refs.anexosOcorrencia) this.$refs.anexosOcorrencia.abrirGerenciador();
          });
        })
        .catch(error => {
          const data = error && error.response && error.response.data;
          const mensagem = typeof data === 'string' && data.trim() ? data : 'Não foi possível carregar os anexos da ocorrência.';
          this.alertaMensager(mensagem, 'Erro', 'error');
        })
        .finally(() => { this.carregandoAnexosId = null; });
    },

    obterIdCheckListItem(itemOcorrencia) {
      if (!itemOcorrencia) return null;
      const ocorrencia = itemOcorrencia.ocorrencia || {};
      const relacoes = [
        itemOcorrencia.checkListItem,
        itemOcorrencia.checklistItem,
        itemOcorrencia.itemCheckList,
        itemOcorrencia.itemChecklist,
        ocorrencia.checkListItem,
        ocorrencia.checklistItem,
        ocorrencia.itemCheckList,
        ocorrencia.itemChecklist
      ];
      const relacao = relacoes.find(item => item && item.idCheckListItem);
      return itemOcorrencia.idCheckListItem || ocorrencia.idCheckListItem || (relacao && relacao.idCheckListItem) || null;
    },

    carregarOcorrencias() {
      OcorrenciaService.buscarOcorrenciasChecklist()
        .then(res => {
          let dados = res.data;
          // console.log(dados);
          if (typeof dados === 'string') {
            try {
              dados = JSON.parse(dados);
            } catch (e) {
              console.error('Erro ao parsear dados:', e);
              dados = [];
            }
          }
          let listaProblemas = Array.isArray(dados) ? dados : [];
          this.ocorrenciasAgrupadas = [];
          this.problemasOrfaos = [];
          
          let agrupadosMap = new Map();

          listaProblemas.forEach(item => {
             if (!item.ocorrencia) {
                this.problemasOrfaos.push(item);
             } else {
                let idOco = item.ocorrencia.idOcorrencia;
                if (!agrupadosMap.has(idOco)) {
                   agrupadosMap.set(idOco, {
                      ocorrencia: item.ocorrencia,
                      problemas: []
                   });
                }

                if (item.idOcorrenciaProblema && item.idOcorrenciaProblema > 0) {
                    agrupadosMap.get(idOco).problemas.push(item);
                }
             }
          });
          
          this.ocorrenciasAgrupadas = Array.from(agrupadosMap.values());
          this.ocorrenciasAgrupadas.sort((a, b) => b.ocorrencia.idOcorrencia - a.ocorrencia.idOcorrencia);
          this.totalRows = this.ocorrenciasAgrupadas.length;
        })
        .catch(err => {
          console.error(err);
          this.alertaMensager('Erro ao carregar os chamados do setor', 'Erro', 'error');
        });
    },
    sincronizar() {
      this.sincronizando = true;
      OcorrenciaService.sincronizarManual()
        .then(() => {
          this.alertaMensager('Sincronização concluída com sucesso', 'Sucesso', 'success');
          this.carregarOcorrencias();
        })
        .catch(err => {
          console.error(err);
          this.alertaMensager('Erro ao sincronizar chamados', 'Erro', 'error');
        })
        .finally(() => {
          this.sincronizando = false;
        });
    },
    formatarData(dataArray) {
      if (!dataArray) return '';
      if (Array.isArray(dataArray) && dataArray.length >= 3) {
        let mes = dataArray[1] < 10 ? '0' + dataArray[1] : dataArray[1];
        let dia = dataArray[2] < 10 ? '0' + dataArray[2] : dataArray[2];
        let dataF = `${dataArray[0]}-${mes}-${dia}`;
        return new Date(dataF).toLocaleDateString('pt-BR');
      } else {
         return new Date(dataArray).toLocaleDateString('pt-BR');
      }
    },
    irParaChecklist(item) {
      if (!item || !item.ocorrencia || !item.ocorrencia.checkList) return;
      const isInventario = item.ocorrencia.checkList.ancora;
      const rota = isInventario ? '/inventario/lista' : '/checklist/lista';
      this.$router.push({ path: rota, query: { id: item.ocorrencia.checkList.idCheckList, origem: 'ocorrencia', visualizando: 'true' } }).catch(()=>{});
    },
    getBadgeVariant(ocorrenciaProblema) {
      if (!ocorrenciaProblema) return 'secondary';
      if (ocorrenciaProblema.statusChamadoGLPI === 'Finalizado') return 'success';
      if (ocorrenciaProblema.statusChamadoGLPI === 'Em Atendimento') return 'primary';
      if (ocorrenciaProblema.statusChamadoGLPI === 'Aberto') return 'warning';

      if (ocorrenciaProblema.finalizado) return 'success';
      if (ocorrenciaProblema.idChamado) return 'primary';
      return 'warning'; // Pendente de criar chamado ou enviar
    },
    mapStatus(ocorrenciaProblema) {
      if (!ocorrenciaProblema) return 'Desconhecido';
      if (ocorrenciaProblema.statusChamadoGLPI) return ocorrenciaProblema.statusChamadoGLPI;

      if (ocorrenciaProblema.finalizado) return 'Concluído';
      if (ocorrenciaProblema.idChamado) return 'Em Atendimento';
      return 'Pendente';
    },
    statusGeralOcorrencia(itemAgrupado) {
      if (!itemAgrupado || !itemAgrupado.problemas || itemAgrupado.problemas.length === 0) {
        if (itemAgrupado && itemAgrupado.ocorrencia) {
            let s = itemAgrupado.ocorrencia.status;
            if (s === 'Fin' || s === 'Concluído') return 'Finalizado';
            if (s === 'Ema') return 'Em Atendimento';
        }
        return 'Aberto';
      }
      
      let todosConcluidos = true;
      let todosPendentes = true;
      let algumEmAtendimento = false;

      for (let prob of itemAgrupado.problemas) {
        let status = this.mapStatus(prob);
        if (status !== 'Concluído' && status !== 'Finalizado') todosConcluidos = false;
        if (status !== 'Pendente' && status !== 'Aberto') todosPendentes = false;
        if (status === 'Em Atendimento') algumEmAtendimento = true;
      }

      if (todosConcluidos) return 'Finalizado';
      if (algumEmAtendimento || (!todosConcluidos && !todosPendentes)) return 'Em Atendimento';
      return 'Aberto';
    },
    varianteStatusGeral(statusStr) {
      if (statusStr === 'Finalizado' || statusStr === 'Concluído') return 'success';
      if (statusStr === 'Em Atendimento') return 'primary';
      return 'warning';
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filtroPersonalizado(item, filter) {
      if (!filter) return true;
      const termo = filter.toLowerCase();

      const idMatch = item.ocorrencia && item.ocorrencia.idOcorrencia.toString() === termo;
      const idChecklistMatch = item.ocorrencia && item.ocorrencia.checkList && item.ocorrencia.checkList.idCheckList.toString() === termo;
      
      let localStr = "";
      if (item.ocorrencia) {
        if (item.ocorrencia.bloco) localStr += item.ocorrencia.bloco.descricao + " ";
        if (item.ocorrencia.andar) localStr += item.ocorrencia.andar.descricao + " ";
        if (item.ocorrencia.sala) localStr += (item.ocorrencia.sala.descricaoCompleta || item.ocorrencia.sala.descricao);
      }
      const localMatch = localStr.toLowerCase().includes(termo);

      const problemasMatch = item.problemas && item.problemas.some(p => {
         const pDesc = p.problema && p.problema.descricao ? p.problema.descricao.toLowerCase() : '';
         const pStatus = this.mapStatus(p).toLowerCase();
         const pChamado = p.idChamado ? p.idChamado.toString() : '';
         const pIdProb = p.idOcorrenciaProblema ? p.idOcorrenciaProblema.toString() : '';
         
         return pDesc.includes(termo) || pStatus.includes(termo) || pChamado === termo || pIdProb === termo;
      });

      return idMatch || idChecklistMatch || localMatch || problemasMatch;
    },
    alertaMensager(mensagem, titulo, tipo) {
      this.$fire({
        title: titulo,
        text: mensagem,
        type: tipo,
      }).then((r) => {
        r.value;
      });
    }
  }
};
</script>

<style scoped>
</style>
